var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('div',{staticClass:"dashboard_bg_color"},[_c('router-view'),(_vm.incomingCallNotification)?_c('video-call',{attrs:{"callerInfo":_vm.callerInfo,"roomId":_vm.roomId}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }